import React from 'react';

import { Label } from 'semantic-ui-react';

import {
  PriceType,
  TariffComponent as TariffComponentType,
} from 'subdomains/cpo/types/charging-policy';
import { RestrictionLabels } from './RestrictionsLabels';
import { PriceLabel } from './PriceLabel';

type Props = {
  values: TariffComponentType;
  currency: string;
  withoutGroupLabel?: boolean;
};

export const PriceAndRestrictionsLabel = ({
  values,
  currency,
  withoutGroupLabel = false,
}: Props) => {
  const isParking = values.price?.type === PriceType.PARKING_TIME;
  if (withoutGroupLabel) {
    return (
      <>
        <PriceLabel price={values.price} currency={currency} />
        <RestrictionLabels
          isParking={isParking}
          restrictions={values.restrictions}
        />
      </>
    );
  }

  return (
    <Label basic style={{ marginRight: 0, marginLeft: 0 }}>
      <PriceLabel price={values.price} currency={currency} />
      <RestrictionLabels
        isParking={isParking}
        restrictions={values.restrictions}
      />
    </Label>
  );
};
